import MediaViewerContainer from "./MediaViewer";
import MediaViewerReducer from "./reducer";
import {
  setShowMediaViewer,
  setShowSmallViewPort,
  setSelectedMedia,
  setSelectedIndex,
  setDisplay,
  setPanoFullScreen,
  setShowMediaObj,
  setErrorIdx,
  setMediaParam,
  MediaViewerActionTypes,
} from "./actions";

export {
  setShowMediaViewer,
  setShowSmallViewPort,
  setSelectedMedia,
  setSelectedIndex,
  setDisplay,
  setPanoFullScreen,
  setShowMediaObj,
  setErrorIdx,
  setMediaParam,
  MediaViewerReducer,
  MediaViewerActionTypes,
};

export default MediaViewerContainer;
